import { bindCallbacks, statusText } from 'scripts/infrastructure/backends/fake_backend_http/lib/common';

export default class GuidePerformanceService {
  constructor(getDatabase) {
    this.getDatabase = getDatabase;
  }

  findGuidePerformance(attrs, callback, path, { orgId }, query) {
    const defaultDetails = { '1d': [], '7d': [], '30d': [], '90d': [] };
    const guidePerformanceDetails = this.getDatabase(orgId).guidePerformanceDetails || defaultDetails;

    let response = guidePerformanceDetails[query['f.t']] || [];

    const guideCollectionId = query['f.gid'];
    if (guideCollectionId) {
      response = response.filter(({ collectionId }) => collectionId === guideCollectionId);
    }

    const interactionTypeQuery = query['f.it'] || 'ALL';
    response = response.filter(({ interactionType }) => interactionType === interactionTypeQuery);

    callback(null, { status: 200, statusText: statusText(200), response });
  }

  getRoutes() {
    return bindCallbacks(
      {
        '/api/v1/orgs/:orgId/guide-performance': {
          GET: this.findGuidePerformance,
        },
      },
      this
    );
  }
}
